import React from 'react';
import { Grid, GridItem } from '@cad-arc';
import { BoloQueueView } from '@mark43/cad-api';
import { WorkspaceQueue } from '../../panels/workspace-queue';
import { useOpenFrBoloDetails } from './use-open-fr-bolo-details';
import { FrBoloCompactQueueCell } from './fr-bolo-compact-queue-cell';

export const FrBoloCompactQueueRow = ({
    data,
    index,
    queueColumns,
    customGridTemplateColumns,
}: {
    data: BoloQueueView;
    queueColumns: WorkspaceQueue['queueColumns'];
    index: number;
    customGridTemplateColumns?: string | undefined;
}) => {
    const openBoloDetails = useOpenFrBoloDetails();
    const handleOpenBoloDetails = () => {
        if (!data.id) return;
        openBoloDetails(data.id);
    };

    return (
        <Grid
            position="relative"
            data-testid={`fr-bolo-queue-row-${data.id}`}
            width="fit-content"
            data-row-index={index}
            borderBottom="1px solid"
            borderColor="border.default"
            gridTemplateColumns={customGridTemplateColumns || 'var(--columns)'}
            onClick={handleOpenBoloDetails}
            _hover={{
                cursor: 'pointer',
                backgroundColor: 'var(--arc-colors-interactive-hover)',
            }}
        >
            {queueColumns.map((col) => (
                <GridItem key={col.id}>
                    <FrBoloCompactQueueCell col={col} data={data} />
                </GridItem>
            ))}
        </Grid>
    );
};
